import dayjs from "dayjs"
import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import {
  GetAdminEmailChartDataQuery,
  GetAdminEmailListQuery,
  GetAdminEmailTemplatesQuery,
} from "@/api/hasura/generated/graphql"
import { EmailVolume } from "@/models/admin/emailVolume/emailVolume"
import {
  IEmailRecipient,
  IEmailTemplate,
  IEmailVolume,
} from "@/models/admin/emailVolume/emailVolume.types"

type EmailVolumeRaw = GetAdminEmailListQuery["email_messages"][number]
type EmailChartRaw = GetAdminEmailChartDataQuery["email_messages"][number]
type EmailTemplateRaw = GetAdminEmailTemplatesQuery["requests"][number]
type EmailRecipientRaw = NonNullable<EmailVolumeRaw["recipient"]>

export const EmailVolumeParser: IParser<IEmailVolume, EmailVolumeRaw> = {
  toDomain(data) {
    try {
      return new EmailVolume(
        data.id,
        data.status ?? "",
        data.subject ?? "",
        dayjs(data.processed_at),
        data.recipient_id ?? null,
        data.request?.communication_name ?? null,
        data.recipient ? EmailRecipientParser.toDomain(data.recipient) : null,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}

export type EmailChartPoint = {
  status: string
  processedAt: string
  communicationName: string | null
}

export const EmailChartPointParser: IParser<EmailChartPoint, EmailChartRaw> = {
  toDomain(data) {
    try {
      return {
        status: data.status ?? "",
        processedAt: data.processed_at,
        communicationName: data.request?.communication_name ?? null,
      }
    } catch (error) {
      throw new ParseError(error)
    }
  },
}

export const EmailTemplateParser: IParser<IEmailTemplate, EmailTemplateRaw> = {
  toDomain(data) {
    try {
      return { name: data.communication_name }
    } catch (error) {
      throw new ParseError(error)
    }
  },
}

export const EmailRecipientParser: IParser<IEmailRecipient, EmailRecipientRaw> =
  {
    toDomain(data) {
      try {
        return {
          id: data.id,
          email: data.email ?? "",
          name: data.name ?? "",
          accountId: data.account_id ?? null,
          customerId: data.customer_id ?? null,
        }
      } catch (error) {
        throw new ParseError(error)
      }
    },
  }
